import type { RouteObject } from 'react-router';
import { lazyComponent } from '@/platform/lazyComponent';
import { Require } from '@/platform/Require';

const MedicalDashboard = lazyComponent(() => import('./MedicalDashboard').then((module) => module.MedicalDashboard));
const MedicalAthleteTab = lazyComponent(() => import('./athlete/MedicalAthleteTab').then((module) => module.MedicalAthleteTab));
const MedicalOverview = lazyComponent(() => import('./athlete/MedicalOverview').then((module) => module.MedicalOverview));
const AllergiesPanel = lazyComponent(() => import('./athlete/AllergiesPanel').then((module) => module.AllergiesPanel));
const ConditionsPanel = lazyComponent(() => import('./athlete/ConditionsPanel').then((module) => module.ConditionsPanel));

/** `/medical` is the doctor's dashboard. */
export const medicalRoutes: RouteObject[] = [{ path: 'medical', element: <Require permission="medical.view"><MedicalDashboard /></Require> }];

/**
 * The Medical tab on an athlete's page, mounted under the Athletes module's `athlete` route. Each section requires its own permission, so a person who may
 * read allergies but not conditions reaches the one and is refused the other (the service refuses too).
 */
export const medicalAthleteRoutes: RouteObject[] = [
  {
    path: 'medical',
    element: <Require permission="medical.view"><MedicalAthleteTab /></Require>,
    children: [
      { index: true, element: <MedicalOverview /> },
      { path: 'allergies', element: <Require permission="medical_allergy.view"><AllergiesPanel /></Require> },
      { path: 'conditions', element: <Require permission="medical_condition.view"><ConditionsPanel /></Require> },
    ],
  },
];
